import React from 'react';

const ProductDetailSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 pt-24 pb-12 grid md:grid-cols-2 gap-10 animate-pulse">
      {/* Left: Image */}
      <div>
        <div className="w-full h-96 bg-gray-200 rounded-lg mb-4"></div>
        <div className="flex gap-2">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div key={idx} className="w-20 h-20 bg-gray-200 rounded" />
          ))}
        </div>
      </div>

      {/* Right: Info */}
      <div className="space-y-4">
        <div className="w-16 h-6 bg-gray-300 rounded" />
        <div className="w-2/3 h-8 bg-gray-300 rounded" />
        <div className="flex gap-2">
          <div className="w-16 h-6 bg-gray-200 rounded" />
          <div className="w-16 h-6 bg-gray-200 rounded" />
        </div>
        <div className="h-20 bg-gray-100 rounded" />
        <div className="w-1/3 h-8 bg-gray-300 rounded" />
        <div className="w-1/2 h-6 bg-gray-200 rounded" />
        <div className="flex gap-2">
          <div className="w-16 h-8 bg-gray-200 rounded" />
          <div className="w-16 h-8 bg-gray-200 rounded" />
          <div className="w-16 h-8 bg-gray-200 rounded" />
        </div>
        <div className="h-10 bg-gray-300 rounded w-full mt-4" />
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
